import TimeButton from './timeButton.vue';

export default TimeButton;